export const getMaxApplePayVersion = () => {
    let version = 15;

    while (version > 0) {
        if (ApplePaySession.supportsVersion(version)) {
            return version;
        }
        version -= 1;
    }

    return version;
};
